import uuidv4 from "uuid/v4";

export type Guid = string;

function generate(): Guid {
    return uuidv4();
}

export { generate };
